import { createGlobalStyle } from 'styled-components';
import Theme from '../Theme/Theme';

const StyledSelect = createGlobalStyle`

   .ant-select-dropdown{
      background-color: ${Theme.color['white']};
      padding: 0;
      border-radius: 0 0 ${Theme.radius['md']} ${Theme.radius['md']};
      font-family: ${Theme.typography.fontFamily};

      .rc-virtual-list-holder{
         padding-right: 12px;
      }
      .rc-virtual-list-scrollbar{
         width: 12px!important;
      }

      hr{
         margin:  0 ${Theme.spacing['s05']};
      }
      .ant-select-item-option{
         border-radius: 0;
         width: 100%;
         
         &:not(.ant-select-group){
            padding:  ${Theme.spacing['s03']} ${Theme.spacing['s05']};
            &:hover{
               background-color: ${Theme.color['black-1']};    
                .ant-select-item-option-content .ant-checkbox-wrapper, .ant-select-item-option-content{
                   color: ${Theme.color['white']};
        
                }
             }
         }

         &.ant-select-group{

            &:hover{
               width: 100%;
               background-color: ${Theme.color['white']};    
                .ant-select-item-option-content .ant-checkbox-wrapper:hover{
                  background-color: ${Theme.color['black-1']};    
                  color: ${Theme.color['white']};
                }
             }

             .ant-checkbox-group{
               width: 100%;

               .ant-checkbox-group-item{
                  padding:  ${Theme.spacing['s03']} ${Theme.spacing['s05']};
               }
             }
         }

          .ant-select-item-option-content{
            width: 100%;
            font-family: ${Theme.typography.fontFamily.inter};
          }

         &.ant-select-item-option-selected{
            background-color: transparent;
            .ant-select-item-option-content{
               color: ${Theme.color['blue-4']};
            }
         }

         .ant-select-item-option-active{
            background-color: ${Theme.color['white']};

            &:hover{
               background-color: ${Theme.color['black-1']};    
            .ant-select-item-option-content .ant-checkbox-wrapper{
               color: ${Theme.color['white']};
            }
            }
         }
      }
      .ant-select-item{
         padding: 0;

         &.ant-select-item-option-active{
            background-color: ${Theme.color['white']};    
         }
      }
      .ant-select-item-group{
         color: ${Theme.color['blue-4']};
         border-top: 1px solid ${Theme.color['coolgray-4']};
         border-radius:0;
         margin: ${Theme.spacing['s03']} ${Theme.spacing['s05']} 0;
         padding: ${Theme.spacing['s05']} 0;

         .ant-checkbox-group-item{
            &:hover{
               background-color: ${Theme.color['black-1']};    
               color: ${Theme.color['white']};
            }
         }
      }

      .ant-select-item-group:first-of-type{
         border-top: none;
      }
   }

   .select-xl-text {
      margin: ${Theme.spacing.s04} 0;
      .ant-select {
         .ant-select-selector{
            .ant-select-selection-item{
               font-size: ${Theme.typography.fontSize.text_lg_desktop}
            }
         }
      }
   }

   .ant-select {
      &.full-width{
         width:100%;
      }
      

      .ant-select-selector {
         background-color: ${Theme.color['neutral-1']};
         width: auto;
         align-items: center;
         border: none;
         padding: 0 ${Theme.spacing['s05']};

         .ant-select-selection-item{
            color: ${Theme.color['coolgray-11']};
         
         }
   

         .ant-select-selection-placeholder{
            color: ${Theme.color['coolgray-11']};
         }

         .ant-select-arrow{
            .anticon {
               color: ${Theme.color['blue-4']}!important; //Not working 
            }
         } 

         .ant-select-selection-search{
            .ant-select-selection-search-input{
               height: 56px;
            }
         }
      }

      &:hover {
         .ant-select-selector{
            background-color: ${Theme.color['white']};
         }     
      }

      &.ant-select-status-error{
         .ant-select-selector{
            background-color: ${Theme.color['error-1']};
         }

         &:hover {
            .ant-select-selector{
               background-color: ${Theme.color['error-2']};
            }
         }
      } 

      &.ant-select-disabled {
         .ant-select-selector{
            background-color: ${Theme.color['neutral-0.5']};
            .ant-select-selection-item{
               color: ${Theme.color['coolgray-4']};
            
            }
         }

         &:hover {
            .ant-select-selector{
               background-color: ${Theme.color['neutral-0.5']};
            }
         }
      }

      

      .with-bg-color {
      
      }
   } 
   
   .synergy-dark-theme .ant-select .ant-select-selector {
      background-color: red;
   }
`;

export default StyledSelect;

